import { Record } from "immutable";
import * as moment from "moment";
import { IMedia, MEDIA_TYPE_UNKNOWN } from "constants/media";
import { ITag } from "queries/pages";

const defaults = {
    asset_id: null,
    kind: MEDIA_TYPE_UNKNOWN,
    url: null,

    image_id: "",
    image_ids: [],
    upload_id: "",
    tags: [],
};

export class Asset extends Record(defaults) {
    declare asset_id: string;
    declare kind: IMedia;
    declare url: string;

    declare image_id?: string;
    declare image_ids?: string[];
    declare media_id?: string;
    declare upload_id?: string;

    declare tags?: Array<ITag>;

    constructor(args) {
        super({
            ...args,
            created_at_ms: moment.utc(args.created_at_ms),
        });
    }
}
